
define('text!templates/pages/dashboard/sessions.ejs',[],function () { return '<table class="table table-hover" style="font-size: 10px; height: 100%;">\n    <thead>\n    </thead>\n\n    <tbody style="height: 100%;">\n        <tr><td class="loading alert">Загрузка</td><td class="empty alert">Сессий на сегодня нет</td></tr>\n    </tbody>\n</table>';});

